import { FC } from "react";
import { Icon, IconProps } from "../../../icons/components/Icon";
import { useTheme } from "../../../styles/theme";

export const RequisitionStatusApprovedIcon: FC<IconProps> = (props) => {
  const theme = useTheme();
  return (
    <Icon height="24px" {...props} viewBox="0 0 34 33">
      <circle
        opacity="0.1"
        cx="17.0249"
        cy="16.5"
        r="16.5"
        fill={theme.colors.grey}
      />
      <g clipPath="url(#clip0_7868_65366)">
        <path
          d="M21.9204 11.8242C21.613 11.8242 21.3638 11.575 21.3638 11.2676V7H13.3853C12.4645 7 11.7153 7.74913 11.7153 8.66992V14.8928C11.8987 14.8761 12.0843 14.8672 12.272 14.8672C14.1693 14.8672 15.8678 15.7347 16.9918 17.0938H23.0337C23.3411 17.0938 23.5903 17.343 23.5903 17.6504C23.5903 17.9578 23.3411 18.207 23.0337 18.207H17.7251C18.0731 18.886 18.2974 19.6382 18.3695 20.4336H23.0337C23.3411 20.4336 23.5903 20.6828 23.5903 20.9902C23.5903 21.2976 23.3411 21.5469 23.0337 21.5469H18.3695C18.203 23.3852 17.2208 24.9916 15.7884 26H24.5181C25.4389 26 26.188 25.2509 26.188 24.3301V11.8242H21.9204ZM23.0337 14.8672H14.8696C14.5622 14.8672 14.313 14.618 14.313 14.3105C14.313 14.0031 14.5622 13.7539 14.8696 13.7539H23.0337C23.3411 13.7539 23.5903 14.0031 23.5903 14.3105C23.5903 14.618 23.3411 14.8672 23.0337 14.8672Z"
          fill={theme.colors.green}
        />
        <path
          d="M22.4771 7.32593V10.7109H25.8618L22.4771 7.32593Z"
          fill={theme.colors.green}
        />
        <path
          d="M12.2853 15.9568C9.51549 15.9568 7.26221 18.2101 7.26221 20.9799C7.26221 23.7468 9.51549 26.0001 12.2853 26.0001C15.0522 26.0001 17.3055 23.7468 17.3055 20.9799C17.3055 18.2101 15.0522 15.9568 12.2853 15.9568ZM14.4674 20.1962L12.0627 22.6008C11.9469 22.7166 11.7955 22.776 11.6441 22.776C11.4927 22.776 11.3383 22.7166 11.2225 22.6008L10.1003 21.4787C9.86877 21.2471 9.86877 20.8701 10.1003 20.6385C10.3319 20.4069 10.7089 20.4069 10.9405 20.6385L11.6441 21.3421L13.6302 19.356C13.8617 19.1244 14.2358 19.1244 14.4674 19.356C14.6989 19.5876 14.6989 19.9646 14.4674 20.1962Z"
          fill={theme.colors.green}
        />
      </g>
      <defs>
        <clipPath id="clip0_7868_65366">
          <rect
            width="19"
            height="19"
            fill={theme.colors.white}
            transform="translate(7.2251 7)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};
